import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Class merge for the UI system: clsx for conditionals, tailwind-merge so a
 * caller's `className` beats a component's default class on the same property
 * (the pattern every existing wrapper hand-rolled with template strings).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
